import { AuthService } from '@affine/core/modules/cloud';
import { useLiveData, useService } from '@toeverything/infra';
import { useLayoutEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const TERMS_ACCEPTANCE_PATH = '/terms-acceptance';

const TERMS_EXEMPT_EXACT_PATHS = new Set([
  TERMS_ACCEPTANCE_PATH,
  '/sign-in',
  '/sign-In',
  '/signIn',
  '/desktop-signin',
  '/magic-link',
  '/oauth/login',
  '/oauth/callback',
  '/404',
  '/expired',
  '/account-reactivate',
]);

const TERMS_EXEMPT_PREFIXES = ['/auth/', '/open-app/'];

function isTermsExemptPath(pathname: string) {
  return (
    TERMS_EXEMPT_EXACT_PATHS.has(pathname) ||
    TERMS_EXEMPT_PREFIXES.some(prefix => pathname.startsWith(prefix))
  );
}

export function buildTermsAcceptanceRedirect(currentPath: string) {
  return `${TERMS_ACCEPTANCE_PATH}?redirect_uri=${encodeURIComponent(
    currentPath || '/'
  )}`;
}

export const TermsAcceptanceGate = () => {
  const authService = useService(AuthService);
  const status = useLiveData(authService.session.status$);
  const needsTermsAcceptance = useLiveData(
    authService.session.needsTermsAcceptance$
  );
  const location = useLocation();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    if (
      status !== 'authenticated' ||
      !needsTermsAcceptance ||
      isTermsExemptPath(location.pathname)
    ) {
      return;
    }

    navigate(
      buildTermsAcceptanceRedirect(
        `${location.pathname}${location.search}${location.hash}`
      ),
      { replace: true }
    );
  }, [
    location.hash,
    location.pathname,
    location.search,
    navigate,
    needsTermsAcceptance,
    status,
  ]);

  return null;
};
